// extracted by mini-css-extract-plugin
export default {"icon":"Icon__icon____mUuV"};